import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { CurrentContextService } from 'app/core/current-context.service';

@Component({
  selector: 'app-assets-brand-settings-view',
  templateUrl: './brand-settings-view.component.html',
  styleUrls: ['./brand-settings-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BrandSettingsViewComponent {
  private readonly currentContextService = inject(CurrentContextService);

  protected readonly customer = toSignal(
    this.currentContextService.currentContextBS.pipe(map((ctx) => ctx?.customer ?? null)),
    { initialValue: null },
  );

  protected readonly user = toSignal(
    this.currentContextService.currentContextBS.pipe(map((ctx) => ctx?.user ?? null)),
    { initialValue: null },
  );
}
